import {
  createSlice,
  PayloadAction,
  Slice,
  CaseReducerActions,
  SliceCaseReducers,
  AnyAction,
} from "@reduxjs/toolkit";
import { Reducer } from "react";
import { RootState, AppThunk } from ".";
import { ProaService, IProaService } from "../services/proyecta/proa-form.service";
import { FollowupService, IFollowupService } from "../services/proyecta/followup.service";
import { Utilities } from "@utils";

export interface IPopState {
  allBudgets: any;
  allBudgetDetails: any;
  stepsData: any;
  followUpData: any;
  openModal: boolean;
  infoToDelete: any;
  finishAlert: boolean;
}
  
export class PopStore {
  reducer: Reducer<any, AnyAction>;
  service: IProaService;
  followUpService: IFollowupService;
  initialState: IPopState;
  initialDeatailState: any;
  slice: Slice;
  actions: CaseReducerActions<SliceCaseReducers<any>>;

  selectAllBudgets: any;
  selectAllBudgetDetails: any;
  selectStepsData: any;
  selectFollowUpData: any;
  selectOpenModal: any;
  selectFinishAlert: any;
  selectInfoToDelete: any;

  constructor() {
    this.pop();
  }

  private pop() {
    this.service = new ProaService();
    this.followUpService = new FollowupService();
    this.initialState = this.stateInit();
    this.slice = createSlice({
      name: "pop",
      initialState: this.initialState,
      reducers: this.reducersInit(),
    });

    this.actions = this.slice.actions;
    this.reducer = this.slice.reducer;

    this.selectorsInit();
  }

  private reducersInit() {
    return {
      setAllBudgets: (state: IPopState, action: PayloadAction<any>) => {
        state.allBudgets = action.payload;
      },
      setAllBudgetDetails: (state: IPopState, action: PayloadAction<any>) => {
        state.allBudgetDetails = action.payload;
      },
      setStepsData: (state: IPopState, action: PayloadAction<any>) => {
        state.stepsData = action.payload;
      },
      setFollowUpData: (state: IPopState, action: PayloadAction<any>) => {
        state.followUpData = action.payload;
      },
      setOpenModal: (state: IPopState, action: PayloadAction<any>) => {
        state.openModal = action.payload;
      },
      setFinishAlert: (state: IPopState, action: PayloadAction<any>) => {
        state.finishAlert = action.payload;
      },
      setInfoToDelete: (state: IPopState, action: PayloadAction<any>) => {
        state.infoToDelete = action.payload;
      },
    };
  }

  private selectorsInit() {
    this.selectAllBudgets = (state: RootState) => state.pop.allBudgets;
    this.selectAllBudgetDetails = (state: RootState) => state.pop.allBudgetDetails;
    this.selectStepsData = (state: RootState) => state.pop.stepsData;
    this.selectFollowUpData = (state: RootState) => state.pop.followUpData;
    this.selectOpenModal = (state: RootState) => state.pop.openModal;
    this.selectFinishAlert = (state: RootState) => state.pop.finishAlert;
    this.selectInfoToDelete = (state: RootState) => state.pop.infoToDelete;
  }

  private stateInit() {
    let state: IPopState = {
      allBudgets: null,
      allBudgetDetails: null,
      stepsData: null,
      followUpData: null,
      openModal: false,
      infoToDelete: null,
      finishAlert: false
    };
    return state;
  }

  public getAllBudgets = (): AppThunk => (dispatch) => {
    this.service
      .getBasicBudgets()
      .then((budgets: any) => {
        dispatch(this.actions.setAllBudgets(budgets));
      })
      .catch((err) => Utilities.writeInConsoleLog(err));
  };

  public getAllBudgetDetails = (): AppThunk => (dispatch) => {
    this.service
      .getAllBudgetDetails()
      .then((details: any) => {
        dispatch(this.actions.setAllBudgetDetails(details));
      })
      .catch((err) => Utilities.writeInConsoleLog(err));
  };

  public getStepsData = (clear: boolean = false): AppThunk => (dispatch) => {
    if(clear){
      dispatch(this.actions.setStepsData(null));
    }else{
      this.service
        .getAllStepsData()
        .then((data: any) => {
          dispatch(this.actions.setStepsData(data));
        })
        .catch((err) => Utilities.writeInConsoleLog(err));
    }
  };

  public getAllFollowupData = (clear: boolean = false): AppThunk => (dispatch, getState) => {
    if(clear){
      dispatch(this.actions.setFollowUpData(null));
    }else{
      this.followUpService
        .getAllFollowupData()
        .then((followUpData: any) => {
          dispatch(this.actions.setFollowUpData(followUpData));
        })
        .catch((err) => Utilities.writeInConsoleLog(err));
    }
  };

  public handleOpenModal = (value: boolean = false): AppThunk => (dispatch) => {
      dispatch(this.actions.setOpenModal(value));
  };

  public handleInfoToDelete = (infoFollowUp: any, itemsToDelete: any): AppThunk => (dispatch) => {
    if(!infoFollowUp && !itemsToDelete){
      dispatch(this.actions.setInfoToDelete(null));
    }else{
      let infoToDelete = {infoFollowUp, itemsToDelete}
      dispatch(this.actions.setInfoToDelete(infoToDelete));
    }
  };

  public showFinishAlert = (value: boolean = false): AppThunk => (dispatch) => {
    dispatch(this.actions.setFinishAlert(value));
  };
  
}